import { CdkScrollable } from '@angular/cdk/overlay';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Subscription } from 'rxjs';
import { CompanyProductPhaseTaskTimeAutocalcSetting } from 'src/app/models/company_product_phase_task_time_autocalc_setting.model';
import { SecondsToStringTimePipe } from 'src/app/pipes/seconds-to-string-time.pipe';

@Component({
  selector: 'app-company-product-phase-task-time-autocalc-settings-dialog',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatIcon,
    MatSuffix,
    SecondsToStringTimePipe,
    MatHint,
  ],
  templateUrl: './company-product-phase-task-time-autocalc-settings-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './company-product-phase-task-time-autocalc-settings-dialog.component.css',
})
export class CompanyProductPhaseTaskTimeAutocalcSettingsDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CompanyProductPhaseTaskTimeAutocalcSettingsDialogComponent>>(MatDialogRef);
  data = inject<{
    company_product_phase_task_time_autocalc_settings: CompanyProductPhaseTaskTimeAutocalcSetting[];
  }>(MAT_DIALOG_DATA);

  devTime: number = 0;
  company_product_phase_task_time_autocalc_settings: CompanyProductPhaseTaskTimeAutocalcSettingCustom[] = [];

  constructor() {
    this.company_product_phase_task_time_autocalc_settings = this.data.company_product_phase_task_time_autocalc_settings.map(setting => {
      return {
        ...setting,
        value: setting.prcnt,
      };
    });
  }

  ngOnInit(): void {
    this.calculateExample();
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(this.company_product_phase_task_time_autocalc_settings);
  }

  calculateExample() {
    const dev_setting = this.company_product_phase_task_time_autocalc_settings.filter(
      setting => !setting.company_product_phase_task_time_autocalc_setting_category.is_editable
    )[0];
    dev_setting.value = 3600;

    this.company_product_phase_task_time_autocalc_settings.forEach(setting => {
      if (setting.company_product_phase_task_time_autocalc_setting_category.is_editable) {
        setting.value = (3600 * setting.prcnt) / 100;
      }
    });
  }
}

interface CompanyProductPhaseTaskTimeAutocalcSettingCustom extends CompanyProductPhaseTaskTimeAutocalcSetting {
  value: number;
}
